// extracted by mini-css-extract-plugin
module.exports = {"CardWrapper":"CardWrapper___3hJ9A"};